import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { TOOLS_GUIDE_MD } from '@snipit/core/utils/toolsGuideContent';

// Static imports to allow Vite to bundle images properly
import imgMockData from '../../../docs/screenshots/tools_mock_data.png';
import imgColorConverter from '../../../docs/screenshots/tools_color_converter.png';
import imgMarkdownPad from '../../../docs/screenshots/tools_markdown_pad.png';
import imgJwtDecoder from '../../../docs/screenshots/tools_jwt_decoder.png';
import imgRegexTester from '../../../docs/screenshots/tools_regex_tester.png';
import imgBoilerplateGen from '../../../docs/screenshots/tools_boilerplate_gen.png';
import imgBase64Url from '../../../docs/screenshots/tools_base64_url.png';
import imgCaseConverter from '../../../docs/screenshots/tools_case_converter.png';
import imgJsonFormatter from '../../../docs/screenshots/tools_json_formatter.png';
import imgHashGenerator from '../../../docs/screenshots/tools_hash_generator.png';

const imageMap = {
  'tools_mock_data.png': imgMockData,
  'tools_color_converter.png': imgColorConverter,
  'tools_markdown_pad.png': imgMarkdownPad,
  'tools_jwt_decoder.png': imgJwtDecoder,
  'tools_regex_tester.png': imgRegexTester,
  'tools_boilerplate_gen.png': imgBoilerplateGen,
  'tools_base64_url.png': imgBase64Url,
  'tools_case_converter.png': imgCaseConverter,
  'tools_json_formatter.png': imgJsonFormatter,
  'tools_hash_generator.png': imgHashGenerator
};

const ToolsGuideView = ({ setView }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    const renderMarkdown = async () => {
      let content = TOOLS_GUIDE_MD;
      
      // Replace image paths with bundled Vite paths
      for (const [filename, bundledPath] of Object.entries(imageMap)) {
        content = content.replace(new RegExp(`\\.\\./screenshots/${filename}`, 'g'), bundledPath);
      }
      
      const parsed = await marked.parse(content);
      setHtml(parsed);
    };
    renderMarkdown();
  }, []);

  return (
    <div className="flex-1 flex flex-col h-full bg-background overflow-hidden">
      {/* Header */}
      <header className="flex items-center p-3 bg-surface border-b border-gray-800 shrink-0">
        <button
          onClick={() => setView('help')}
          className="p-1.5 text-gray-400 hover:text-white rounded-md hover:bg-gray-800 transition mr-2"
        >
          <ArrowLeft size={18} />
        </button>
        <h1 className="text-sm font-bold text-white flex items-center gap-2">
          🧰 Tools Vault Guide
        </h1>
      </header>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6 scrollbar-hide">
        <div 
          className="max-w-3xl mx-auto prose prose-invert prose-sm"
          dangerouslySetInnerHTML={{ 
            __html: DOMPurify.sanitize(html, {
              ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|chrome-extension|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
            }) 
          }}
        />
      </div>
    </div>
  );
};

export default ToolsGuideView;
